import SatBotAlert from './SatBotAlert';
export default SatBotAlert;
